import React from 'react';
import { EditorState } from 'draft-js';
import RedoIcon from '@mui/icons-material/Redo';

class RedoButton extends React.PureComponent {
  render() {
    const { theme, onChange, editorState } = this.props;

    return (
      <div className={theme.buttonWrapper} onMouseDown={event => event.preventDefault()}>
        <button
          type="button"
          className={theme.button}
          disabled={editorState.getRedoStack().size === 0}
          onClick={event => {
            event.stopPropagation();
            onChange(EditorState.redo(editorState));
          }}
        >
          <RedoIcon />
        </button>
      </div>
    );
  }
}

export default RedoButton;
